import { NavItemSchema } from '@shared/interfaces/nav/nav-item-schema';

export const meteringPointNavSchema: NavItemSchema[] = [
  {
    title: 'Overblik',
    routeTemplate: ['/meteringpoint', '{id}']
  },
  {
    title: 'Måler',
    routeTemplate: ['/meteringpoint', '{id}', 'meter']
  },
  {
    title: 'Beregning',
    routeTemplate: ['/meteringpoint', '{id}', 'calculation']
  },
  {
    title: 'Tidsserier',
    routeTemplate: ['/meteringpoint', '{id}', 'timeseries']
  },
  {
    title: 'Stamdata',
    routeTemplate: ['/meteringpoint', '{id}', 'coredata']
  },
  {
    title: 'Forretningstransaktioner',
    routeTemplate: ['/meteringpoint', '{id}', 'transactions']
  },
  {
    title: 'Priselementer',
    routeTemplate: ['/meteringpoint', '{id}', 'pricing']
  },
  {
    title: 'Historik',
    routeTemplate: ['/meteringpoint', '{id}', 'history']
  }
];
